"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFastTables = createFastTables;
exports.deleteArea = deleteArea;
exports.deleteTable = deleteTable;
exports.deleteTableSeat = deleteTableSeat;
exports.downloadImportTemplate = downloadImportTemplate;
exports.exportTableCode = exportTableCode;
exports.getAreaList = getAreaList;
exports.getTableList = getTableList;
exports.imageExport = imageExport;
exports.importTableData = importTableData;
exports.saveArea = saveArea;
exports.syncSeat = syncSeat;
exports.updateTable = updateTable;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getTableList(query) {
  return (0, _requestAuth.default)({
    url: '/xyTable/page',
    method: 'get',
    params: query
  });
}
function syncSeat(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/syncSeat',
    method: 'post',
    data: data
  });
}
function updateTable(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/update',
    method: 'post',
    data: data
  });
}
function deleteTableSeat(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/deleteSeat',
    method: 'post',
    data: data
  });
}
function deleteTable(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/delete',
    method: 'post',
    data: data
  });
}
function imageExport(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/imageExport',
    method: 'post',
    data: data
  });
}
function exportTableCode(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/exportTableCode',
    method: 'post',
    data: data
  });
}

// 导入客位信息
function importTableData(formData) {
  return (0, _requestAuth.default)({
    url: '/xyTable/importTable',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 下载导入模板
function downloadImportTemplate() {
  return (0, _requestAuth.default)({
    url: '/xyTable/downloadImportTemplate',
    method: 'get',
    responseType: 'blob'
  });
}

// 批量创建快餐客位码
function createFastTables(data) {
  return (0, _requestAuth.default)({
    url: '/xyTable/createFastTables',
    method: 'post',
    data: data
  });
}

// ==================== 客位区域相关 ====================

// 获取店铺客位区域列表
function getAreaList(storeId) {
  return (0, _requestAuth.default)({
    url: "/xyTableArea/list/".concat(storeId),
    method: 'get'
  });
}

// 保存或更新客位区域
function saveArea(data) {
  return (0, _requestAuth.default)({
    url: '/xyTableArea/save',
    method: 'post',
    data: data
  });
}

// 删除客位区域
function deleteArea(areaId) {
  return (0, _requestAuth.default)({
    url: "/xyTableArea/delete/".concat(areaId),
    method: 'post'
  });
}